import IconButton from "components/Button/IconButton";
import { dataEmpty } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";

const TimeSalesCntTable = ({ reportState }) => {
  const resultTableInst = new resultTable();
  const [totalCnt, setTotalCnt] = useState(0);

  useEffect(() => {
    const sum =
      reportState.gx_period_time.length > 0
        ? reportState.gx_period_time[0].am +
          reportState.gx_period_time[0].pm +
          reportState.gx_period_time[0].holiday
        : 0;
    setTotalCnt(sum);
  }, [reportState]);

  return (
    <div>
      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
        <IconButton type="border" />
        <Label labelText="시간대별 판매 수량" marginLeft="0.5rem" fontWeight="bold" />
      </div>
      <CustomTable
        columns_head={resultTableInst.columns_head}
        table_title={resultTableInst.table_title}
        rest_call={resultTableInst.get_data_from_rest}
        row_render={resultTableInst.create_table}
        rest_data={reportState.gx_period_time}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
        <TextField
          labelText="합계"
          labelWidth="3rem"
          textBoxWidth="10rem"
          textMarginRight="0rem"
          isNumber
          defaultValue={totalCnt.toLocaleString()}
          endAdornment={"건"}
          disabled
        />
      </div>
    </div>
  );
};
export default TimeSalesCntTable;

class resultTable {
  table_title = "";

  // constructor() {}

  create_table = (data, idx) => {
    return (
      <CustomRow style={{}} key={idx}>
        <CustomTableContents $bgColor="#dfebf3">판매 수량</CustomTableContents>
        <CustomTableContents $isNumber>{data.am}</CustomTableContents>
        <CustomTableContents $isNumber>{data.pm}</CustomTableContents>
        {/* <CustomTableContents>data.holiday</CustomTableContents> */}
      </CustomRow>
    );
  };

  columns_head = [
    { title: "구분", width: "25%" },
    { title: "오전", width: "25%" },
    { title: "오후", width: "25%" },
    // { title: "공휴일", width: "25%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
